import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DiopazoneLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M8.77 4 6 7m0 0 2.77 3M6 7h12m0 0-2.77-3M18 7l-2.77 3" }), _jsx("path", { stroke: "currentColor", d: "M2 2v20M6 16v6M10 16v6M14 16v6M18 16v6M22 2v20" })] }) });
}
const DiopazoneLightCustom = forwardRef(_DiopazoneLightCustom);
export { DiopazoneLightCustom };
